import { xyIntegration } from 'ml-spectra-processing';
import generateID from '../../../generateID';
export function mapRanges(ranges, datum) {
    const { x, re } = datum.data;
    return ranges.map((newRange) => {
        const absolute = xyIntegration({ x, y: re }, { from: newRange.from, to: newRange.to, reverse: true });
        const signals = (newRange.signals || []).map((signal) => {
            const { kind = null, id, js = [], diaIDs = [], ...resSignal } = signal;
            return {
                ...resSignal,
                kind: kind || 'signal',
                js,
                id: id || generateID(),
                diaIDs,
            };
        });
        return {
            ...newRange,
            id: newRange.id || generateID(),
            kind: signals?.[0].kind || 'signal',
            absolute,
            signals,
        };
    });
}
//# sourceMappingURL=mapRanges.js.map